<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="TOC_Contents ParaOverride-1"><span epub:type="pagebreak" id="pagevii" title="vii"></span></p>
<p class="_ded" id="_idParaDest-2">Dedication</p>
<p class="tx-ni">This book was the work of many people who must be recognized.</p>
<p class="tx">This would not have been possible without Patricia’s love and support. Her patience, guidance, and confidence were invaluable for making this possible. I could never have done it without her. Her knowledge of reclaiming Witchcraft ritual practices, organization, and theater are major influences on this book.</p>
<p class="tx">The ideas and practices Sophia Fate-Changer and other members of the little community we made in the Bay Area were the seed that grew into this book. Her ideas, uncompromising stands for the right thing, brainstorming, and partnership in crime made this unique form of practice possible.</p>
<p class="tx">Maia’s combination of patience and blunt advice were critical for refining community practices, working through some serious mistakes on the journey here, and reaching a point where this book could happen. Thank you for your example and honing of this rough blade.</p>
<p class="tx">Kevin is an unparalleled lore master. Whenever I had questions on any Old Norse subject, no matter how obscure, he always had an excellent, thorough answer along with recommendations of many brilliant academic works. </p>
<p class="tx">Dave’s experiences in many parts of the Norse Pagan and Heathen communities were key for understanding both the broader movement and what this book represents. He gave essential insights for explaining clearly why the neo-Volkisch are a danger for all people, including to members of that sect and our broader community.</p>
<p class="tx">My fellow workers Steve and Morgen have been major inspirations for me through their knowledge and their example. May their work continue and see rich fruit.</p>
<p class="tx">When I first got started as a Pagan, my experiences in San Diego were some of the most critical in my life. The guidance I received helped set me on the right path before I knew I was on it. </p>
<p class="tx">I would not be who I am or have written this without my family or their love and support.</p>
<p class="tx _idGenParaOverride-1">This book is dedicated to all who feel the pull of the Norse gods and see their example as a way forward in these troubled times. Regardless of where you come from or how you live, I hope this work inspires, guides, and gives you everything you need for building a meaningful, fulfilling practice.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?13f62e0e